'use strict';

/**
 * All needed JS for and within the main navigation bar
 *
 * @type {{burgerMenuAnimation: waNavigation.burgerMenuAnimation, navBarSearch: waNavigation.navBarSearch, waLogin: waNavigation.waLogin}}
 */
var waNavigation = {
	/**
	 * Does change the burger menu icon for responsive views
	 */
	burgerMenuAnimation: function() {
		$('.website-menu').on('shown.bs.collapse', function() {
			$(this).parent().find('.fa-bars').removeClass('fa-bars').addClass('fa-times');
		}).on('hidden.bs.collapse', function() {
			$(this).parent().find('.fa-times').removeClass('fa-times').addClass('fa-bars');
		});
	},
	showSearchBar: function() {
		$('.navigation-toggle').toggle();
		$('.fa-bars').hide();
	},
	closeSearchBar: function() {
		$('.navigation-toggle').toggle();
		$('.fa-bars').show();
	},
	navBarSearch: function() {
		$('#global-search-input').closest('.float-label-control').remove();
		// This has been changed to hitting the "enter" button, since everyone
		// was complaining that the Search triggered without people being "ready"
		// Needs to be called event because of firefox. Nobody knows why...
		$('#global-search-input').keydown(function(event) {
			let keyCode = (event.keyCode ? event.keyCode : event.which);
			if (keyCode == 13) {
				window.location = '/' + waApp.getLanguage() + '/search?term=' + $(this).val();
			}
		});

		$('#global-search-submit').on( "click", function() {
			window.location = '/' + waApp.getLanguage() + '/search?term=' + $('#global-search-input').val();
		});

		$('.global-search-icon').click(function() {
			waNavigation.showSearchBar();
		});

		$('#global-search-close-icon').click(function() {
			waNavigation.closeSearchBar();
		});
	},
};
